import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  MenTShirtVariants_White, MenTShirtVariants_Black, MenTShirtVariants_Grey,
  MenCollarTShirtVariants_White, MenCollarTShirtVariants_Black, MenCollarTShirtVariants_Grey,
  MenShirtVariants_White, MenShirtVariants_Black, MenShirtVariants_Grey,
  MenHoodieVariants_White, MenHoodieVariants_Black, MenHoodieVariants_Grey,

  WomenTShirtVariants_White, WomenTShirtVariants_Black, WomenTShirtVariants_Grey,
  WomenCollarTShirtVariants_White, WomenCollarTShirtVariants_Black, WomenCollarTShirtVariants_Grey,
  WomenShirtVariants_White, WomenShirtVariants_Black, WomenShirtVariants_Grey,
  WomenHoodieVariants_White, WomenHoodieVariants_Black, WomenHoodieVariants_Grey,
  WomenCropTShirtVariants_White, WomenCropTShirtVariants_Black, WomenCropTShirtVariants_Grey,

  BoysTShirtVariants_White, BoysTShirtVariants_Black, BoysTShirtVariants_Grey,
  BoysCollarTShirtVariants_White, BoysCollarTShirtVariants_Black, BoysCollarTShirtVariants_Grey,
  BoysShirtVariants_White, BoysShirtVariants_Black, BoysShirtVariants_Grey,
  BoysHoodieVariants_White, BoysHoodieVariants_Black, BoysHoodieVariants_Grey,

  GirlsTShirtVariants_White, GirlsTShirtVariants_Black, GirlsTShirtVariants_Grey,
  GirlsCollarTShirtVariants_White, GirlsCollarTShirtVariants_Black, GirlsCollarTShirtVariants_Grey,
  GirlsShirtVariants_White, GirlsShirtVariants_Black, GirlsShirtVariants_Grey,
  GirlsHoodieVariants_White, GirlsHoodieVariants_Black, GirlsHoodieVariants_Grey,

} from "../components/ProductVariants"
import {
  MenTShirtSizeTable, MenShirtSizeTable, MenHoodieSizeTable, WomenTShirtSizeTable, WomenCropTShirtSizeTable, KidHoodieSizeTable,
  MenCollarTShirtSizeTable, WomenCollarTShirtSizeTable, KidShirtSizeTable, KidTShirtSizeTable, KidCollarTShirtSizeTable,

} from "../components/ProductSizes"
import { smoothScrollToTop} from "../components/ScrollToTop"
import { Link } from "react-router-dom";
import { Card, Row, Col, Button, Image, Dropdown } from 'antd';
import { Animated } from "react-animated-css";
import "../assets/css/choose-prduct.css"
import ProductList from '../assets/images/Icons/product-list.png';
import ManImage from '../assets/images/Icons/man.png';
import WomanImage from '../assets/images/Icons/woman.png';
import GirlImage from '../assets/images/Icons/girl.png';
import BoyImage from '../assets/images/Icons/boy.png';
import BabyImage from '../assets/images/Icons/baby.png';
import MugImage from '../assets/images/Icons/mug.png';
import PhoneCoverImage from '../assets/images/Icons/phone-cover.png';
import TShirtBlank from '../assets/images/Icons/TShirt-Blank.png';
import TShirtBlack from '../assets/images/Designer/TshirtFrontDesignBlack.png';
import TShirtWhite from '../assets/images/Designer/TshirtFrontDesign.png';
import TShirtGrey from '../assets/images/Designer/TshirtFrontGrayDesign.png';
import WomenTShirtBlack from '../assets/images/Designer/WomenTShirtBlackFrontDesign.png';
import WomenTShirtWhite from '../assets/images/Designer/WomenTshirtFrontDesign.png';
import WomenTShirtGrey from '../assets/images/Designer/WomenTShirtGreyFrontDesign.png'; 
import CropTShirtBlank from '../assets/images/Icons/Crop-TShirt-Blank.png';
import CropTShirtBlack from '../assets/images/Designer/CropTshirtFrontBlack.png';
import CropTShirtWhite from '../assets/images/Designer/CropTshirtFrontWhite.png';
import CropTShirtGrey from '../assets/images/Designer/CropTshirtFrontGrey.png';
import ShirtBlank from '../assets/images/Icons/Shirt-Blank.png';
import ShirtBlack from '../assets/images/Designer/MenDorsFrontBlack.png';
import ShirtWhite from '../assets/images/Designer/MenDorsFrontWhite.png';
import ShirtGrey from '../assets/images/Designer/MenDorsFrontGrey.png';
import KidShirtBlack from '../assets/images/Designer/KidDorsFrontBlack.png';
import KidShirtWhite from '../assets/images/Designer/KidDorsFrontWhite.png';
import KidShirtGrey from '../assets/images/Designer/KidDorsFrontGrey.png';
import HoodieBlank from '../assets/images/Icons/Hoodie-Blank.png';
import HoodieBlack from '../assets/images/Designer/MenHoodieBlaackFront.png';
import HoodieWhite from '../assets/images/Designer/MenHoodieWhiteFront.png';
import HoodieGrey from '../assets/images/Designer/MenHoodieGreyFront.png';
import CollarTShirtBlank from '../assets/images/Icons/T-Shirt-Collar-Blank.png';
import CollarTShirtBlack from '../assets/images/Designer/CollarTshirtBlackFront.png';
import CollarTShirtWhite from '../assets/images/Designer/CollarTshirtFrontWhite.png';
import CollarTShirtGrey from '../assets/images/Designer/CollarTShirtFrontGrey.png';
import WomenCollarTShirtBlack from '../assets/images/Designer/WomenCollarFrontBlack.png';
import WomenCollarTShirtWhite from '../assets/images/Designer/WomanCollarFrontWhite.png';
import WomenCollarTShirtGrey from '../assets/images/Designer/WomenCollarfrontGrey.png';
import { getUnorderableProducts } from '../services/productApi';

const { Meta } = Card;

const ChooseProduct = () => {
  const navigate = useNavigate();
  const [visibleTypeIndex, setVisibleTypeIndex] = useState(["products","men", "women", "boys", "girls", "mugs", "phoneCovers", "babies", "puzzle"])
  const [visibleTypeCanvas, setVisibleTypeCanvas] = useState("")
  const [visibleMenProduct, setVisibleMenProduct] = useState(false)
  const [visibleWomenProduct, setVisibleWomenProduct] = useState(false)
  const [visibleBoysProduct, setVisibleBoysProduct] = useState(false)
  const [visibleGirlsProduct, setVisibleGirlsProduct] = useState(false)
  const [kidTableTypeVisible, setKidTableTypeVisible] = useState(false)
  const [isTypeCardsVisible, setIsTypeCardsVisible] = useState(true)
  const [isSizeCardsVisible, setIsSizeCardsVisible] = useState(false)
  const [selectedProductType, setSelectedProductType] = useState("")
  const [selectedProductColor, setSelectedProductColor] = useState("")
  const [selectedProductQuality, setSelectedProductQuality] = useState("")
  const [selectedProductSize, setSelectedProductSize] = useState("")
  const [productSizeTableElement, setProductSizeTableElement] = useState(null)
  const [productSizeCardImage, setProductSizeCardImage] = useState(null)
  const [animationOutType, setAnimationOutType] = useState("fadeOut")
  const [unorderableProducts, setUnorderableProducts] = useState([]);

  useEffect(() => {
    const fetchUnorderableProducts = async () => {
      try {
        const response = await getUnorderableProducts();
        const data = response.data.ObjList || [];
        setUnorderableProducts(data);
      } catch (error) {
        console.error('Error fetching unorderable products:', error);
      }
    };
    
    fetchUnorderableProducts();
  }, []);

  const handlevisibleType = (index) => {
    setVisibleTypeIndex([index,])
    setVisibleTypeCanvas(index)
    setTimeout(
      () => {
        setAnimationOutType("fadeOutLeft")
        setVisibleTypeIndex([])

        setTimeout(
          () => {
            setIsTypeCardsVisible(false);
            switch (index) {
              case "men":

                setVisibleMenProduct(true);
                break;

              case "women":

                setVisibleWomenProduct(true);
                break;

              case "boys":

                setVisibleBoysProduct(true);
                break;

              case "girls":

                setVisibleGirlsProduct(true);
                break;

            }
          },
          1000
        );

      },
      700
    );
  }

  const handleDesigningPageLink = (size) => {
    setSelectedProductSize(size)

    navigate("/designer/" + selectedProductType + "-" + selectedProductColor + "-" + selectedProductQuality + "-" + size);
  }

  const handleMenuClick = (e) => {
    smoothScrollToTop()
    setVisibleMenProduct(false)
    setSelectedProductType(e.key.split("-")[0])
    setSelectedProductColor(e.key.split("-")[1])
    setSelectedProductQuality(e.key.split("-")[2])

    switch (e.key.split("-")[0]) {

      // MEN 
      case "MenTShirt":

        setProductSizeTableElement(MenTShirtSizeTable)
        switch (e.key.split("-")[1]) {
          case "White":
            setProductSizeCardImage(TShirtWhite)
            break;
          case "Black":
            setProductSizeCardImage(TShirtBlack)
            break;
          case "Grey":
            setProductSizeCardImage(TShirtGrey)
            break;
        }
        break;

      case "MenCollarTShirt":

        setProductSizeTableElement(MenCollarTShirtSizeTable)
        switch (e.key.split("-")[1]) {
          case "White":
            setProductSizeCardImage(CollarTShirtWhite)
            break;
          case "Black":
            setProductSizeCardImage(CollarTShirtBlack)
            break;
          case "Grey":
            setProductSizeCardImage(CollarTShirtGrey)
            break;
        }
        break;

      case "MenShirt":

        setProductSizeTableElement(MenShirtSizeTable)
        switch (e.key.split("-")[1]) {
          case "White":
            setProductSizeCardImage(ShirtWhite)
            break;
          case "Black":
            setProductSizeCardImage(ShirtBlack)
            break;
          case "Grey":
            setProductSizeCardImage(ShirtGrey)
            break;
        }
        break;

      case "MenHoodie":
        setProductSizeTableElement(MenHoodieSizeTable)
        switch (e.key.split("-")[1]) {
          case "White":
            setProductSizeCardImage(HoodieWhite)
            break;
          case "Black":
            setProductSizeCardImage(HoodieBlack)
            break;
          case "Grey":
            setProductSizeCardImage(HoodieGrey)
            break;
        }
        break;


      // WOMEN

      case "WomenTShirt":

        setProductSizeTableElement(WomenTShirtSizeTable)
        switch (e.key.split("-")[1]) {
          case "White":
            setProductSizeCardImage(WomenTShirtWhite)
            break;
          case "Black":
            setProductSizeCardImage(WomenTShirtBlack)
            break;
          case "Grey":
            setProductSizeCardImage(WomenTShirtGrey)
            break;
        }
        break;

      case "WomenCollarTShirt":

        setProductSizeTableElement(WomenCollarTShirtSizeTable)
        switch (e.key.split("-")[1]) {
          case "White":
            setProductSizeCardImage(WomenCollarTShirtWhite)
            break;
          case "Black":
            setProductSizeCardImage(WomenCollarTShirtBlack)
            break;
          case "Grey":
            setProductSizeCardImage(WomenCollarTShirtGrey)
            break;
        }
        break;

      case "WomenShirt":

        setProductSizeTableElement(MenShirtSizeTable)
        switch (e.key.split("-")[1]) {
          case "White":
            setProductSizeCardImage(ShirtWhite)
            break;
          case "Black":
            setProductSizeCardImage(ShirtBlack)
            break;
          case "Grey":
            setProductSizeCardImage(ShirtGrey)
            break;
        }
        break;

      case "WomenHoodie":
        setProductSizeTableElement(MenHoodieSizeTable)
        switch (e.key.split("-")[1]) {
          case "White":
            setProductSizeCardImage(HoodieWhite)
            break;
          case "Black":
            setProductSizeCardImage(HoodieBlack)
            break;
          case "Grey":
            setProductSizeCardImage(HoodieGrey)
            break;
        }
        break;

      case "WomenCropTShirt":
        setProductSizeTableElement(WomenCropTShirtSizeTable)
        switch (e.key.split("-")[1]) {
          case "White":
            setProductSizeCardImage(CropTShirtWhite)
            break;
          case "Black":
            setProductSizeCardImage(CropTShirtBlack)
            break;
          case "Grey":
            setProductSizeCardImage(CropTShirtGrey)
            break;
        }
        break;


      // BOYS 
      case "BoysTShirt":
        setKidTableTypeVisible(true);
        setProductSizeTableElement(KidTShirtSizeTable)
        switch (e.key.split("-")[1]) {
          case "White":
            setProductSizeCardImage(TShirtWhite)
            break;
          case "Black":
            setProductSizeCardImage(TShirtBlack)
            break;
          case "Grey":
            setProductSizeCardImage(TShirtGrey)
            break;
        }
        break;

      case "BoysCollarTShirt":
        setKidTableTypeVisible(true);
        setProductSizeTableElement(KidCollarTShirtSizeTable)
        switch (e.key.split("-")[1]) {
          case "White":
            setProductSizeCardImage(CollarTShirtWhite)
            break;
          case "Black":
            setProductSizeCardImage(CollarTShirtBlack)
            break;
          case "Grey":
            setProductSizeCardImage(CollarTShirtGrey)
            break;
        }
        break;

      case "BoysShirt":
        setKidTableTypeVisible(true);
        setProductSizeTableElement(KidShirtSizeTable)
        switch (e.key.split("-")[1]) {
          case "White":
            setProductSizeCardImage(KidShirtWhite)
            break;
          case "Black":
            setProductSizeCardImage(KidShirtBlack)
            break;
          case "Grey":
            setProductSizeCardImage(KidShirtGrey)
            break;
        }
        break;

      case "BoysHoodie":
        setKidTableTypeVisible(true);
        setProductSizeTableElement(KidHoodieSizeTable)
        switch (e.key.split("-")[1]) {
          case "White":
            setProductSizeCardImage(HoodieWhite)
            break;
          case "Black":
            setProductSizeCardImage(HoodieBlack)
            break;
          case "Grey":
            setProductSizeCardImage(HoodieGrey)
            break;
        }
        break;



      // BOYS 
      case "GirlsTShirt":
        setKidTableTypeVisible(true);
        setProductSizeTableElement(KidTShirtSizeTable)
        switch (e.key.split("-")[1]) {
          case "White":
            setProductSizeCardImage(TShirtWhite)
            break;
          case "Black":
            setProductSizeCardImage(TShirtBlack)
            break;
          case "Grey":
            setProductSizeCardImage(TShirtGrey)
            break;
        }
        break;

      case "GirlsCollarTShirt":
        setKidTableTypeVisible(true);
        setProductSizeTableElement(KidCollarTShirtSizeTable)
        switch (e.key.split("-")[1]) {
          case "White":
            setProductSizeCardImage(CollarTShirtWhite)
            break;
          case "Black":
            setProductSizeCardImage(CollarTShirtBlack)
            break;
          case "Grey":
            setProductSizeCardImage(CollarTShirtGrey)
            break;
        }
        break;

      case "GirlsShirt":
        setKidTableTypeVisible(true);
        setProductSizeTableElement(KidShirtSizeTable)
        switch (e.key.split("-")[1]) {
          case "White":
            setProductSizeCardImage(KidShirtWhite)
            break;
          case "Black":
            setProductSizeCardImage(KidShirtBlack)
            break;
          case "Grey":
            setProductSizeCardImage(KidShirtGrey)
            break;
        }
        break;

      case "GirlsHoodie":
        setKidTableTypeVisible(true);
        setProductSizeTableElement(KidHoodieSizeTable)
        switch (e.key.split("-")[1]) {
          case "White":
            setProductSizeCardImage(HoodieWhite)
            break;
          case "Black":
            setProductSizeCardImage(HoodieBlack)
            break;
          case "Grey":
            setProductSizeCardImage(HoodieGrey)
            break;
        }
        break;


    }

    setTimeout(
      () => {
        setIsTypeCardsVisible(false);
        setIsSizeCardsVisible(true);

      },
      1000
    );

  };


  return (
    <Row align={"center"}>
      <Row>
        {isSizeCardsVisible && !kidTableTypeVisible && (
          <Col span={24}>
            <Animated
              animationIn="fadeInUp"
              animationInDuration={1200}
              animationOutDuration={0}
              isVisible={isSizeCardsVisible}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0" }}

                style={{ width: "100%", minWidth: "350px", borderRadius: "16px 16px 16px 16px" }}
              >
                <Row style={{ flex: 1, alignItems: 'center' }}>
                  <Col align="center" style={{ paddingRight: "30px", paddingLeft: "30px" }} md={10} span={24}>
                    <Image src={productSizeCardImage} preview={false} />
                    <p className="font-4">انتخاب سایز</p>
                  </Col>
                  <Col align="center" className="p-2" md={14} span={24}>
                    {productSizeTableElement}
                  </Col>
                </Row>
                <Row className="size-select-bg">
                  <Col span={0} lg={3}><Button onClick={() => handleDesigningPageLink("S")} className="size-select-right">S</Button></Col>
                  <Col span={0} lg={3}><Button onClick={() => handleDesigningPageLink("M")} className="size-select">M</Button></Col>
                  <Col span={0} lg={3}><Button onClick={() => handleDesigningPageLink("L")} className="size-select">L</Button></Col>
                  <Col span={0} lg={3}><Button onClick={() => handleDesigningPageLink("XL")} className="size-select">XL</Button></Col>
                  <Col span={0} lg={3}><Button onClick={() => handleDesigningPageLink("2XL")} className="size-select">2XL</Button></Col>
                  <Col span={0} lg={3}><Button onClick={() => handleDesigningPageLink("3XL")} className="size-select">3XL</Button></Col>
                  <Col span={0} lg={3}><Button onClick={() => handleDesigningPageLink("4XL")} className="size-select">4XL</Button></Col>
                  <Col span={0} lg={3}><Button onClick={() => handleDesigningPageLink("5XL")} className="size-select-left">5XL</Button></Col>

                  <Col span={6} lg={0}><Button onClick={() => handleDesigningPageLink("S")} className="size-select-sm-top-right">S</Button></Col>
                  <Col span={6} lg={0}><Button onClick={() => handleDesigningPageLink("M")} className="size-select-sm-top">M</Button></Col>
                  <Col span={6} lg={0}><Button onClick={() => handleDesigningPageLink("L")} className="size-select-sm-top">L</Button></Col>
                  <Col span={6} lg={0}><Button onClick={() => handleDesigningPageLink("XL")} className="size-select-sm-top">XL</Button></Col>
                  <Col span={6} lg={0}><Button onClick={() => handleDesigningPageLink("2XL")} className="size-select-sm-bottom-right">2XL</Button></Col>
                  <Col span={6} lg={0}><Button onClick={() => handleDesigningPageLink("3XL")} className="size-select-sm-bottom">3XL</Button></Col>
                  <Col span={6} lg={0}><Button onClick={() => handleDesigningPageLink("4XL")} className="size-select-sm-bottom">4XL</Button></Col>
                  <Col span={6} lg={0}><Button onClick={() => handleDesigningPageLink("5XL")} className="size-select-sm-left">5XL</Button></Col>
                </Row>
              </Card>

            </Animated>

          </Col>
        )}

        {isSizeCardsVisible && kidTableTypeVisible && (
          <Col span={24}>
            <Animated
              animationIn="fadeInUp"
              animationInDuration={1200}
              animationOutDuration={0}
              isVisible={isSizeCardsVisible}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0" }}

                style={{ width: "100%", minWidth: "350px", borderRadius: "16px 16px 16px 16px" }}
              >
                <Row style={{ flex: 1, alignItems: 'center' }}>
                  <Col align="center" style={{ paddingRight: "30px", paddingLeft: "30px" }} md={9} span={24}>
                    <Image src={productSizeCardImage} preview={false} />
                    <p className="font-4">انتخاب سایز</p>
                  </Col>
                  <Col align="center" className="p-2" md={15} span={24}>
                    {productSizeTableElement}
                  </Col>
                </Row>
                <Row className="size-select-bg">
                  <Col span={0} lg={6}><Button onClick={() => handleDesigningPageLink("6to8")} className="size-select-right">6-8 سال</Button></Col>
                  <Col span={0} lg={6}><Button onClick={() => handleDesigningPageLink("9to10")} className="size-select">9-10 سال</Button></Col>
                  <Col span={0} lg={6}><Button onClick={() => handleDesigningPageLink("11to12")} className="size-select">11-12 سال</Button></Col>
                  <Col span={0} lg={6}><Button onClick={() => handleDesigningPageLink("13to14")} className="size-select-left">13-14 سال</Button></Col>

                  <Col span={6} lg={0}><Button onClick={() => handleDesigningPageLink("6to8")} className="size-select-sm-bottom-right">6-8 سال</Button></Col>
                  <Col span={6} lg={0}><Button onClick={() => handleDesigningPageLink("9to10")} className="size-select-sm-bottom">9-10 سال</Button></Col>
                  <Col span={6} lg={0}><Button onClick={() => handleDesigningPageLink("11to12")} className="size-select-sm-bottom">11-12 سال</Button></Col>
                  <Col span={6} lg={0}><Button onClick={() => handleDesigningPageLink("13to14")} className="size-select-sm-left">13-14 سال</Button></Col>

                </Row>
              </Card>

            </Animated>

          </Col>
        )}

      </Row>
      {!isSizeCardsVisible && isTypeCardsVisible && (
        <Row style={{ maxWidth: "1200px" }} gutter={[24, 24]} align={"center"}>

          <Col align="center" span={12} md={8} xl={6}>
            <Animated
              animationOut={animationOutType}
              animationInDuration={1000}
              animationOutDuration={1000}
              isVisible={visibleTypeIndex.includes("products")}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0 0 15px 0" }}
                hoverable
                style={{
                  minWidth: 130,
                }}
                onClick={() => navigate("/products")}
                cover={<img height={280} src={ProductList} />}
              >
                <p className="fYekan-bold font-3">محصولات آماده</p>
              </Card>

            </Animated>
          </Col>

          <Col align="center" span={12} md={8} xl={6}>
            <Animated
              animationOut={animationOutType}
              animationInDuration={1000}
              animationOutDuration={1000}
              isVisible={visibleTypeIndex.includes("men")}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0 0 15px 0" }}
                hoverable
                style={{
                  minWidth: 130,
                }}
                onClick={() => {smoothScrollToTop();handlevisibleType("men")}}
                cover={<img height={280} src={ManImage} />}
              >
                <p className="fYekan-bold font-3">پوشاک مردانه</p>
              </Card>

            </Animated>
          </Col>

          <Col align="center" span={12} md={8} xl={6}>
            <Animated
              animationOut={animationOutType}
              animationInDuration={1000}
              animationOutDuration={1000}
              isVisible={visibleTypeIndex.includes("women")}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0 0 15px 0" }}
                hoverable
                style={{
                  minWidth: 130,
                }}
                onClick={() => {smoothScrollToTop();handlevisibleType("women")}}
                cover={<img height={280} src={WomanImage} />}
              >
                <p className="fYekan-bold font-3">پوشاک زنانه</p>
              </Card>

            </Animated>
          </Col>

          <Col align="center" span={12} md={8} xl={6}>
            <Animated
              animationOut={animationOutType}
              animationInDuration={1000}
              animationOutDuration={1000}
              isVisible={visibleTypeIndex.includes("boys")}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0 0 15px 0" }}
                hoverable
                style={{
                  minWidth: 130,
                }}
                onClick={() => {smoothScrollToTop();handlevisibleType("boys")}}
                cover={<img height={280} src={BoyImage} />}
              >
                <p className="fYekan-bold font-3">پوشاک پسرانه</p>
              </Card>

            </Animated>
          </Col>

          <Col align="center" span={12} md={8} xl={6}>
            <Animated
              animationOut={animationOutType}
              animationInDuration={1000}
              animationOutDuration={1000}
              isVisible={visibleTypeIndex.includes("girls")}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0 0 15px 0" }}
                hoverable
                style={{
                  minWidth: 130,
                }}
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                  handlevisibleType("girls")}}
                cover={<img height={280} src={GirlImage} />}
              >
                <p className="fYekan-bold font-3">پوشاک دخترانه</p>
              </Card>

            </Animated>
          </Col>

          <Col align="center" span={12} md={8} xl={6}>
            <Animated
              animationOut={animationOutType}
              animationInDuration={1000}
              animationOutDuration={1000}
              isVisible={visibleTypeIndex.includes("babies")}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0 0 15px 0" }}

                style={{
                  minWidth: 130,
                  opacity: 0.6
                }}
                // onClick={() => {smoothScrollToTop();handlevisibleType(3)}}
                cover={<img height={278} src={BabyImage} />}
              >
                <p style={{marginTop:"-25px",marginBottom:"7px", color: "red" }}>اتمام موجودی</p>
                <p className="fYekan-bold font-3">پوشاک نوزاد</p>
              </Card>

            </Animated>
          </Col>

          <Col align="center" span={12} md={8} xl={6}>
            <Animated
              animationOut={animationOutType}
              animationInDuration={1000}
              animationOutDuration={1000}
              isVisible={visibleTypeIndex.includes("mugs")}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0 0 15px 0" }}

                style={{
                  minWidth: 130,
                  opacity: 0.6
                }}
                // onClick={() => {smoothScrollToTop();handlevisibleType(3)}}
                cover={<img height={278} src={MugImage} />}
              >
                <p style={{marginTop:"-25px",marginBottom:"7px", color: "red" }}>اتمام موجودی</p>
                <p className="fYekan-bold font-3">ماگ</p>
                
              </Card>

            </Animated>
          </Col>

          <Col align="center" span={12} md={8} xl={6}>
            <Animated
              animationOut={animationOutType}
              animationInDuration={1000}
              animationOutDuration={1000}
              isVisible={visibleTypeIndex.includes("phoneCovers")}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0 0 15px 0" }}

                style={{
                  minWidth: 130,
                  opacity: 0.6
                }}
                // onClick={() => {smoothScrollToTop();handlevisibleType(3)}}
                cover={<img height={278} src={PhoneCoverImage} />}
              >
                <p style={{marginTop:"-25px",marginBottom:"7px", color: "red" }}>اتمام موجودی</p>
                <p className="fYekan-bold font-3">کاور گوشی</p>
              </Card>

            </Animated>
          </Col>

        </Row>
      )}
      <Row style={{ maxWidth: "1200px" }} gutter={[24, 24]} align={"center"}>

        {/* MEN */}
        {!isSizeCardsVisible && !isTypeCardsVisible && (visibleTypeCanvas == "men") && (
          <Col align="center" span={24} md={12}>
            <Animated
              animationOut="fadeOut"
              animationOutDuration={1000}
              animationIn="slideInRight"
              animationInDuration={1000}
              isVisible={visibleMenProduct}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0" }}
                hoverable
                style={{ width: "100%", minWidth: "350px" }}
              >
                <Row style={{ flex: 1, alignItems: 'center' }}>
                  <Col align="center" style={{ paddingRight: "30px", paddingLeft: "30px" }} span={10}>
                    <Image className="smooth-shadow-img" src={TShirtBlank} preview={false} />
                    <p className="font-4">تی شرت</p>
                  </Col>
                  <Col align="center" className="product-blank-bg" span={14}>
                    <Dropdown
                      menu={{
                        items: MenTShirtVariants_White.map(item => ({
                          ...item,
                          onClick: handleMenuClick,
                        })),
                      }}
                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >

                      <Button className='button-vertical-1-3 button-vertical-top fYekan-bold'>
                        <Col className='fYekan-bold' span={9}>
                          سفید
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={TShirtWhite} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: MenTShirtVariants_Black.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}
                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button className='button-vertical-1-3 button-vertical-middle'>
                        <Col className='fYekan-bold' span={9}>
                          سیاه
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={TShirtBlack} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: MenTShirtVariants_Grey.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}
                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button disabled={true} className='button-vertical-1-3 button-vertical-bottom'>
                        <Col className='fYekan-bold' span={9}>
                          ملانژ
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={TShirtGrey} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                  </Col>
                </Row>
              </Card>

            </Animated>
          </Col>
        )}

        {!isSizeCardsVisible && !isTypeCardsVisible && (visibleTypeCanvas == "men") && (
          <Col align="center" span={24} md={12}>
            <Animated
              animationIn="slideInLeft"
              animationInDuration={1000}
              animationOut="fadeOut"
              animationOutDuration={1000}
              isVisible={visibleMenProduct}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0" }}
                hoverable
                style={{ width: "100%", minWidth: "350px" }}
              >
                <Row style={{ flex: 1, alignItems: 'center' }}>
                  <Col align="center" style={{ paddingRight: "30px", paddingLeft: "30px" }} span={10}>
                    <Image className="smooth-shadow-img" src={CollarTShirtBlank} preview={false} />
                    <p className="font-4">تی شرت یقه دار</p>
                  </Col>
                  <Col align="center" className="product-blank-bg" span={14}>
                    <Dropdown
                      menu={{
                        items: MenCollarTShirtVariants_White.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button className='button-vertical-1-3 button-vertical-top fYekan-bold'>
                        <Col className='fYekan-bold' span={9}>
                          سفید
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={CollarTShirtWhite} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: MenCollarTShirtVariants_Black.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button className='button-vertical-1-3 button-vertical-middle'>
                        <Col className='fYekan-bold' span={9}>
                          سیاه
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={CollarTShirtBlack} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: MenCollarTShirtVariants_Grey.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button disabled={true} className='button-vertical-1-3 button-vertical-bottom'>
                        <Col className='fYekan-bold' span={9}>
                          ملانژ
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={CollarTShirtGrey} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>

                  </Col>
                </Row>
              </Card>

            </Animated>
          </Col>
        )}

        {!isSizeCardsVisible && !isTypeCardsVisible && (visibleTypeCanvas == "men") && (
          <Col align="center" span={24} md={12}>
            <Animated
              animationIn="slideInRight"
              animationInDuration={1200}
              animationOut="fadeOut"
              animationOutDuration={1000}
              isVisible={visibleMenProduct}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0" }}
                hoverable
                style={{ width: "100%", minWidth: "350px" }}
              >
                <Row style={{ flex: 1, alignItems: 'center' }}>
                  <Col align="center" style={{ paddingRight: "30px", paddingLeft: "30px" }} span={10}>
                    <Image className="smooth-shadow-img" src={HoodieBlank} preview={false} />
                    <p className="font-4">هودی</p>
                  </Col>
                  <Col align="center" className="product-blank-bg" span={14}>
                    <Dropdown
                      menu={{
                        items: MenHoodieVariants_White.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button className='button-vertical-1-3 button-vertical-top fYekan-bold'>
                        <Col className='fYekan-bold' span={9}>
                          سفید
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={HoodieWhite} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: MenHoodieVariants_Black.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button className='button-vertical-1-3 button-vertical-middle'>
                        <Col className='fYekan-bold' span={9}>
                          سیاه
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={HoodieBlack} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: MenHoodieVariants_Grey.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button disabled={true} className='button-vertical-1-3 button-vertical-bottom'>
                        <Col className='fYekan-bold' span={9}>
                          ملانژ
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={HoodieGrey} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                  </Col>
                </Row>
              </Card>

            </Animated>
          </Col>
        )}

        {!isSizeCardsVisible && !isTypeCardsVisible && (visibleTypeCanvas == "men") && (
          <Col align="center" span={24} md={12}>
            <Animated
              animationIn="slideInLeft"
              animationInDuration={1200}
              animationOut="fadeOut"
              animationOutDuration={1000}
              isVisible={visibleMenProduct}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0" }}
                hoverable
                style={{ width: "100%", minWidth: "350px" }}
              >
                <Row style={{ flex: 1, alignItems: 'center' }}>
                  <Col align="center" style={{ paddingRight: "30px", paddingLeft: "30px" }} span={10}>
                    <Image className="smooth-shadow-img" src={ShirtBlank} preview={false} />
                    <p className="font-4">دورس</p>
                  </Col>
                  <Col align="center" className="product-blank-bg" span={14}>
                    <Dropdown
                      menu={{
                        items: MenShirtVariants_White.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}
                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >

                      <Button className='button-vertical-1-3 button-vertical-top fYekan-bold'>
                        <Col className='fYekan-bold' span={9}>
                          سفید
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={ShirtWhite} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: MenShirtVariants_Black.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button className='button-vertical-1-3 button-vertical-middle'>
                        <Col className='fYekan-bold' span={9}>
                          سیاه
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={ShirtBlack} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: MenShirtVariants_Grey.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}
                      
                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button disabled={true} className='button-vertical-1-3 button-vertical-bottom'>
                        <Col className='fYekan-bold' span={9}>
                          ملانژ
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={ShirtGrey} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>

                  </Col>
                </Row>
              </Card>

            </Animated>
          </Col>
        )}


        {/* WOMEN */}
        {!isSizeCardsVisible && !isTypeCardsVisible && (visibleTypeCanvas == "women") && (
          <Col align="center" span={24} md={12}>
            <Animated
              animationOut="fadeOut"
              animationOutDuration={1000}
              animationIn="slideInRight"
              animationInDuration={1000}
              isVisible={visibleWomenProduct}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0" }}
                hoverable
                style={{ width: "100%", minWidth: "350px" }}
              >
                <Row style={{ flex: 1, alignItems: 'center' }}>
                  <Col align="center" style={{ paddingRight: "30px", paddingLeft: "30px" }} span={10}>
                    <Image className="smooth-shadow-img" src={TShirtBlank} preview={false} />
                    <p className="font-4">تی شرت</p>
                  </Col>
                  <Col align="center" className="product-blank-bg" span={14}>
                    <Dropdown
                      menu={{
                        items: WomenTShirtVariants_White.map(item => ({
                          ...item,
                          onClick: handleMenuClick,
                        })),
                      }}
                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >

                      <Button className='button-vertical-1-3 button-vertical-top fYekan-bold'>
                        <Col className='fYekan-bold' span={9}>
                          سفید
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={WomenTShirtWhite} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: WomenTShirtVariants_Black.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}
                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button className='button-vertical-1-3 button-vertical-middle'>
                        <Col className='fYekan-bold' span={9}>
                          سیاه
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={WomenTShirtBlack} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: WomenTShirtVariants_Grey.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}
                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button disabled={true} className='button-vertical-1-3 button-vertical-bottom'>
                        <Col className='fYekan-bold' span={9}>
                          ملانژ
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={WomenTShirtGrey} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                  </Col>
                </Row>
              </Card>

            </Animated>
          </Col>
        )}

        {!isSizeCardsVisible && !isTypeCardsVisible && (visibleTypeCanvas == "women") && (
          <Col align="center" span={24} md={12}>
            <Animated
              animationIn="slideInLeft"
              animationInDuration={1000}
              animationOut="fadeOut"
              animationOutDuration={1000}
              isVisible={visibleWomenProduct}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0" }}
                hoverable
                style={{ width: "100%", minWidth: "350px" }}
              >
                <Row style={{ flex: 1, alignItems: 'center' }}>
                  <Col align="center" style={{ paddingRight: "30px", paddingLeft: "30px" }} span={10}>
                    <Image className="smooth-shadow-img" src={CollarTShirtBlank} preview={false} />
                    <p className="font-4">تی شرت یقه دار</p>
                  </Col>
                  <Col align="center" className="product-blank-bg" span={14}>
                    <Dropdown
                      menu={{
                        items: WomenCollarTShirtVariants_White.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button className='button-vertical-1-3 button-vertical-top fYekan-bold'>
                        <Col className='fYekan-bold' span={9}>
                          سفید
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={WomenCollarTShirtWhite} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: WomenCollarTShirtVariants_Black.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button className='button-vertical-1-3 button-vertical-middle'>
                        <Col className='fYekan-bold' span={9}>
                          سیاه
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={WomenCollarTShirtBlack} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: WomenCollarTShirtVariants_Grey.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button disabled={true} className='button-vertical-1-3 button-vertical-bottom'>
                        <Col className='fYekan-bold' span={9}>
                          ملانژ
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={WomenCollarTShirtGrey} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>

                  </Col>
                </Row>
              </Card>

            </Animated>
          </Col>
        )}

        {!isSizeCardsVisible && !isTypeCardsVisible && (visibleTypeCanvas == "women") && (
          <Col align="center" span={24} md={12}>
            <Animated
              animationIn="slideInRight"
              animationInDuration={1200}
              animationOut="fadeOut"
              animationOutDuration={1000}
              isVisible={visibleWomenProduct}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0" }}
                hoverable
                style={{ width: "100%", minWidth: "350px" }}
              >
                <Row style={{ flex: 1, alignItems: 'center' }}>
                  <Col align="center" style={{ paddingRight: "30px", paddingLeft: "30px" }} span={10}>
                    <Image className="smooth-shadow-img" src={HoodieBlank} preview={false} />
                    <p className="font-4">هودی</p>
                  </Col>
                  <Col align="center" className="product-blank-bg" span={14}>
                    <Dropdown
                      menu={{
                        items: WomenHoodieVariants_White.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button className='button-vertical-1-3 button-vertical-top fYekan-bold'>
                        <Col className='fYekan-bold' span={9}>
                          سفید
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={HoodieWhite} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: WomenHoodieVariants_Black.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button className='button-vertical-1-3 button-vertical-middle'>
                        <Col className='fYekan-bold' span={9}>
                          سیاه
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={HoodieBlack} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: WomenHoodieVariants_Grey.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button disabled={true} className='button-vertical-1-3 button-vertical-bottom'>
                        <Col className='fYekan-bold' span={9}>
                          ملانژ
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={HoodieGrey} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                  </Col>
                </Row>
              </Card>

            </Animated>
          </Col>
        )}

        {!isSizeCardsVisible && !isTypeCardsVisible && (visibleTypeCanvas == "women") && (
          <Col align="center" span={24} md={12}>
            <Animated
              animationIn="slideInLeft"
              animationInDuration={1200}
              animationOut="fadeOut"
              animationOutDuration={1000}
              isVisible={visibleWomenProduct}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0" }}
                hoverable
                style={{ width: "100%", minWidth: "350px" }}
              >
                <Row style={{ flex: 1, alignItems: 'center' }}>
                  <Col align="center" style={{ paddingRight: "30px", paddingLeft: "30px" }} span={10}>
                    <Image className="smooth-shadow-img" src={ShirtBlank} preview={false} />
                    <p className="font-4">دورس</p>
                  </Col>
                  <Col align="center" className="product-blank-bg" span={14}>
                    <Dropdown
                      menu={{
                        items: WomenShirtVariants_White.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}
                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >

                      <Button className='button-vertical-1-3 button-vertical-top fYekan-bold'>
                        <Col className='fYekan-bold' span={9}>
                          سفید
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={ShirtWhite} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: WomenShirtVariants_Black.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button className='button-vertical-1-3 button-vertical-middle'>
                        <Col className='fYekan-bold' span={9}>
                          سیاه
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={ShirtBlack} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: WomenShirtVariants_Grey.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button disabled={true} className='button-vertical-1-3 button-vertical-bottom'>
                        <Col className='fYekan-bold' span={9}>
                          ملانژ
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={ShirtGrey} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>

                  </Col>
                </Row>
              </Card>

            </Animated>
          </Col>
        )}

        {!isSizeCardsVisible && !isTypeCardsVisible && (visibleTypeCanvas == "women") && (
          <Col align="center" span={24} md={12}>
            <Animated
              animationIn="slideInUp"
              animationInDuration={1400}
              animationOut="fadeOut"
              animationOutDuration={1000}
              isVisible={visibleWomenProduct}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0" }}
                hoverable
                style={{ width: "100%", minWidth: "350px" }}
              >
                <Row style={{ flex: 1, alignItems: 'center' }}>
                  <Col align="center" style={{ paddingRight: "30px", paddingLeft: "30px" }} span={10}>
                    <Image className="smooth-shadow-img" src={CropTShirtBlank} preview={false} />
                    <p className="font-4">کراپ تی شرت</p>
                  </Col>
                  <Col align="center" className="product-blank-bg" span={14}>
                    <Dropdown
                      menu={{
                        items: WomenCropTShirtVariants_White.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}
                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >

                      <Button className='button-vertical-1-3 button-vertical-top fYekan-bold'>
                        <Col className='fYekan-bold' span={9}>
                          سفید
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={CropTShirtWhite} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: WomenCropTShirtVariants_Black.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button className='button-vertical-1-3 button-vertical-middle'>
                        <Col className='fYekan-bold' span={9}>
                          سیاه
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={CropTShirtBlack} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: WomenCropTShirtVariants_Grey.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button disabled={true} className='button-vertical-1-3 button-vertical-bottom'>
                        <Col className='fYekan-bold' span={9}>
                          ملانژ
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={CropTShirtGrey} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>

                  </Col>
                </Row>
              </Card>

            </Animated>
          </Col>
        )}


        {/* BOYS */}
        {!isSizeCardsVisible && !isTypeCardsVisible && (visibleTypeCanvas == "boys") && (
          <Col align="center" span={24} md={12}>
            <Animated
              animationOut="fadeOut"
              animationOutDuration={1000}
              animationIn="slideInRight"
              animationInDuration={1000}
              isVisible={visibleBoysProduct}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0" }}
                hoverable
                style={{ width: "100%", minWidth: "350px" }}
              >
                <Row style={{ flex: 1, alignItems: 'center' }}>
                  <Col align="center" style={{ paddingRight: "30px", paddingLeft: "30px" }} span={10}>
                    <Image className="smooth-shadow-img" src={TShirtBlank} preview={false} />
                    <p className="font-4">تی شرت</p>
                  </Col>
                  <Col align="center" className="product-blank-bg" span={14}>
                    <Dropdown
                      menu={{
                        items: BoysTShirtVariants_White.map(item => ({
                          ...item,
                          onClick: handleMenuClick,
                        })),
                      }}
                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >

                      <Button className='button-vertical-1-3 button-vertical-top fYekan-bold'>
                        <Col className='fYekan-bold' span={9}>
                          سفید
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={TShirtWhite} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: BoysTShirtVariants_Black.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}
                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button className='button-vertical-1-3 button-vertical-middle'>
                        <Col className='fYekan-bold' span={9}>
                          سیاه
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={TShirtBlack} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: BoysTShirtVariants_Grey.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}
                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button disabled={true} className='button-vertical-1-3 button-vertical-bottom'>
                        <Col className='fYekan-bold' span={9}>
                          ملانژ
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={TShirtGrey} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                  </Col>
                </Row>
              </Card>

            </Animated>
          </Col>
        )}

        {!isSizeCardsVisible && !isTypeCardsVisible && (visibleTypeCanvas == "boys") && (
          <Col align="center" span={24} md={12}>
            <Animated
              animationIn="slideInLeft"
              animationInDuration={1000}
              animationOut="fadeOut"
              animationOutDuration={1000}
              isVisible={visibleBoysProduct}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0" }}
                hoverable
                style={{ width: "100%", minWidth: "350px" }}
              >
                <Row style={{ flex: 1, alignItems: 'center' }}>
                  <Col align="center" style={{ paddingRight: "30px", paddingLeft: "30px" }} span={10}>
                    <Image className="smooth-shadow-img" src={CollarTShirtBlank} preview={false} />
                    <p className="font-4">تی شرت یقه دار</p>
                  </Col>
                  <Col align="center" className="product-blank-bg" span={14}>
                    <Dropdown
                      menu={{
                        items: BoysCollarTShirtVariants_White.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button className='button-vertical-1-3 button-vertical-top fYekan-bold'>
                        <Col className='fYekan-bold' span={9}>
                          سفید
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={CollarTShirtWhite} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: BoysCollarTShirtVariants_Black.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button className='button-vertical-1-3 button-vertical-middle'>
                        <Col className='fYekan-bold' span={9}>
                          سیاه
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={CollarTShirtBlack} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: BoysCollarTShirtVariants_Grey.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button disabled={true} className='button-vertical-1-3 button-vertical-bottom'>
                        <Col className='fYekan-bold' span={9}>
                          ملانژ
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={CollarTShirtGrey} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>

                  </Col>
                </Row>
              </Card>

            </Animated>
          </Col>
        )}

        {!isSizeCardsVisible && !isTypeCardsVisible && (visibleTypeCanvas == "boys") && (
          <Col align="center" span={24} md={12}>
            <Animated
              animationIn="slideInRight"
              animationInDuration={1200}
              animationOut="fadeOut"
              animationOutDuration={1000}
              isVisible={visibleBoysProduct}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0" }}
                hoverable
                style={{ width: "100%", minWidth: "350px" }}
              >
                <Row style={{ flex: 1, alignItems: 'center' }}>
                  <Col align="center" style={{ paddingRight: "30px", paddingLeft: "30px" }} span={10}>
                    <Image className="smooth-shadow-img" src={HoodieBlank} preview={false} />
                    <p className="font-4">هودی</p>
                  </Col>
                  <Col align="center" className="product-blank-bg" span={14}>
                    <Dropdown
                      menu={{
                        items: BoysHoodieVariants_White.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button className='button-vertical-1-3 button-vertical-top fYekan-bold'>
                        <Col className='fYekan-bold' span={9}>
                          سفید
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={HoodieWhite} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: BoysHoodieVariants_Black.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button className='button-vertical-1-3 button-vertical-middle'>
                        <Col className='fYekan-bold' span={9}>
                          سیاه
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={HoodieBlack} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: BoysHoodieVariants_Grey.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button disabled={true} className='button-vertical-1-3 button-vertical-bottom'>
                        <Col className='fYekan-bold' span={9}>
                          ملانژ
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={HoodieGrey} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                  </Col>
                </Row>
              </Card>

            </Animated>
          </Col>
        )}

        {!isSizeCardsVisible && !isTypeCardsVisible && (visibleTypeCanvas == "boys") && (
          <Col align="center" span={24} md={12}>
            <Animated
              animationIn="slideInLeft"
              animationInDuration={1200}
              animationOut="fadeOut"
              animationOutDuration={1000}
              isVisible={visibleBoysProduct}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0" }}
                hoverable
                style={{ width: "100%", minWidth: "350px" }}
              >
                <Row style={{ flex: 1, alignItems: 'center' }}>
                  <Col align="center" style={{ paddingRight: "30px", paddingLeft: "30px" }} span={10}>
                    <Image className="smooth-shadow-img" src={ShirtBlank} preview={false} />
                    <p className="font-4">دورس</p>
                  </Col>
                  <Col align="center" className="product-blank-bg" span={14}>
                    <Dropdown
                      menu={{
                        items: BoysShirtVariants_White.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}
                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >

                      <Button className='button-vertical-1-3 button-vertical-top fYekan-bold'>
                        <Col className='fYekan-bold' span={9}>
                          سفید
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={KidShirtWhite} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: BoysShirtVariants_Black.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button className='button-vertical-1-3 button-vertical-middle'>
                        <Col className='fYekan-bold' span={9}>
                          سیاه
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={KidShirtBlack} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: BoysShirtVariants_Grey.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button disabled={true} className='button-vertical-1-3 button-vertical-bottom'>
                        <Col className='fYekan-bold' span={9}>
                          ملانژ
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={KidShirtGrey} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>

                  </Col>
                </Row>
              </Card>

            </Animated>
          </Col>
        )}


        {/* GIRLS */}
        {!isSizeCardsVisible && !isTypeCardsVisible && (visibleTypeCanvas == "girls") && (
          <Col align="center" span={24} md={12}>
            <Animated
              animationOut="fadeOut"
              animationOutDuration={1000}
              animationIn="slideInRight"
              animationInDuration={1000}
              isVisible={visibleGirlsProduct}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0" }}
                hoverable
                style={{ width: "100%", minWidth: "350px" }}
              >
                <Row style={{ flex: 1, alignItems: 'center' }}>
                  <Col align="center" style={{ paddingRight: "30px", paddingLeft: "30px" }} span={10}>
                    <Image className="smooth-shadow-img" src={TShirtBlank} preview={false} />
                    <p className="font-4">تی شرت</p>
                  </Col>
                  <Col align="center" className="product-blank-bg" span={14}>
                    <Dropdown
                      menu={{
                        items: GirlsTShirtVariants_White.map(item => ({
                          ...item,
                          onClick: handleMenuClick,
                        })),
                      }}
                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >

                      <Button className='button-vertical-1-3 button-vertical-top fYekan-bold'>
                        <Col className='fYekan-bold' span={9}>
                          سفید
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={TShirtWhite} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: GirlsTShirtVariants_Black.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}
                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button className='button-vertical-1-3 button-vertical-middle'>
                        <Col className='fYekan-bold' span={9}>
                          سیاه
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={TShirtBlack} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: GirlsTShirtVariants_Grey.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}
                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button disabled={true} className='button-vertical-1-3 button-vertical-bottom'>
                        <Col className='fYekan-bold' span={9}>
                          ملانژ
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={TShirtGrey} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                  </Col>
                </Row>
              </Card>

            </Animated>
          </Col>
        )}

        {!isSizeCardsVisible && !isTypeCardsVisible && (visibleTypeCanvas == "girls") && (
          <Col align="center" span={24} md={12}>
            <Animated
              animationIn="slideInLeft"
              animationInDuration={1000}
              animationOut="fadeOut"
              animationOutDuration={1000}
              isVisible={visibleGirlsProduct}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0" }}
                hoverable
                style={{ width: "100%", minWidth: "350px" }}
              >
                <Row style={{ flex: 1, alignItems: 'center' }}>
                  <Col align="center" style={{ paddingRight: "30px", paddingLeft: "30px" }} span={10}>
                    <Image className="smooth-shadow-img" src={CollarTShirtBlank} preview={false} />
                    <p className="font-4">تی شرت یقه دار</p>
                  </Col>
                  <Col align="center" className="product-blank-bg" span={14}>
                    <Dropdown
                      menu={{
                        items: GirlsCollarTShirtVariants_White.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button className='button-vertical-1-3 button-vertical-top fYekan-bold'>
                        <Col className='fYekan-bold' span={9}>
                          سفید
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={CollarTShirtWhite} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: GirlsCollarTShirtVariants_Black.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button className='button-vertical-1-3 button-vertical-middle'>
                        <Col className='fYekan-bold' span={9}>
                          سیاه
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={CollarTShirtBlack} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: GirlsCollarTShirtVariants_Grey.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button disabled={true} className='button-vertical-1-3 button-vertical-bottom'>
                        <Col className='fYekan-bold' span={9}>
                          ملانژ
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={CollarTShirtGrey} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>

                  </Col>
                </Row>
              </Card>

            </Animated>
          </Col>
        )}

        {!isSizeCardsVisible && !isTypeCardsVisible && (visibleTypeCanvas == "girls") && (
          <Col align="center" span={24} md={12}>
            <Animated
              animationIn="slideInRight"
              animationInDuration={1200}
              animationOut="fadeOut"
              animationOutDuration={1000}
              isVisible={visibleGirlsProduct}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0" }}
                hoverable
                style={{ width: "100%", minWidth: "350px" }}
              >
                <Row style={{ flex: 1, alignItems: 'center' }}>
                  <Col align="center" style={{ paddingRight: "30px", paddingLeft: "30px" }} span={10}>
                    <Image className="smooth-shadow-img" src={HoodieBlank} preview={false} />
                    <p className="font-4">هودی</p>
                  </Col>
                  <Col align="center" className="product-blank-bg" span={14}>
                    <Dropdown
                      menu={{
                        items: GirlsHoodieVariants_White.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button className='button-vertical-1-3 button-vertical-top fYekan-bold'>
                        <Col className='fYekan-bold' span={9}>
                          سفید
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={HoodieWhite} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: GirlsHoodieVariants_Black.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button className='button-vertical-1-3 button-vertical-middle'>
                        <Col className='fYekan-bold' span={9}>
                          سیاه
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={HoodieBlack} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: GirlsHoodieVariants_Grey.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button disabled={true} className='button-vertical-1-3 button-vertical-bottom'>
                        <Col className='fYekan-bold' span={9}>
                          ملانژ
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={HoodieGrey} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                  </Col>
                </Row>
              </Card>

            </Animated>
          </Col>
        )}

        {!isSizeCardsVisible && !isTypeCardsVisible && (visibleTypeCanvas == "girls") && (
          <Col align="center" span={24} md={12}>
            <Animated
              animationIn="slideInLeft"
              animationInDuration={1200}
              animationOut="fadeOut"
              animationOutDuration={1000}
              isVisible={visibleGirlsProduct}
            >
              <Card
                className="light-glass-effect-card"
                bodyStyle={{ padding: "0" }}
                hoverable
                style={{ width: "100%", minWidth: "350px" }}
              >
                <Row style={{ flex: 1, alignItems: 'center' }}>
                  <Col align="center" style={{ paddingRight: "30px", paddingLeft: "30px" }} span={10}>
                    <Image className="smooth-shadow-img" src={ShirtBlank} preview={false} />
                    <p className="font-4">دورس</p>
                  </Col>
                  <Col align="center" className="product-blank-bg" span={14}>
                    <Dropdown
                      menu={{
                        items: GirlsShirtVariants_White.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}
                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >

                      <Button className='button-vertical-1-3 button-vertical-top fYekan-bold'>
                        <Col className='fYekan-bold' span={9}>
                          سفید
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={KidShirtWhite} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: GirlsShirtVariants_Black.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button className='button-vertical-1-3 button-vertical-middle'>
                        <Col className='fYekan-bold' span={9}>
                          سیاه
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={KidShirtBlack} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>
                    <Dropdown
                      menu={{
                        items: GirlsShirtVariants_Grey.map(item => ({
                          ...item,
                          onClick: handleMenuClick,  // Pass the click handler to menu items  
                        })),
                      }}

                      trigger={"click"}
                      placement="bottom"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <Button disabled={true} className='button-vertical-1-3 button-vertical-bottom'>
                        <Col className='fYekan-bold' span={9}>
                          ملانژ
                        </Col>
                        <Col span={15}>
                          <Image height={85} className="smooth-shadow-img" src={KidShirtGrey} preview={false} />
                        </Col>
                      </Button>
                    </Dropdown>

                  </Col>
                </Row>
              </Card>

            </Animated>
          </Col>
        )}

      </Row>
    </Row>
  );
};

export default ChooseProduct;  